import { Injectable } from '@angular/core';
import { RCSInteractionDetails } from '../models/rcs-interaction-details.model';

@Injectable({ providedIn: 'root' })
export class RCSInteractionDetailsAdapter {
  adapt(item: any): RCSInteractionDetails {
    const interaction = new RCSInteractionDetails();
    interaction.interactionID = item.InteractionID || item.interactionID;
    interaction.interactionType = item.InteractionType || item.interactionType;
    const rawDate: string = item.InteractionDate || item.interactionDate;
    // Backend returns UTC timestamps without 'Z' suffix; without it new Date() treats
    // the string as local time instead of UTC. Append 'Z' to parse correctly as UTC.
    if (rawDate) {
      const utcStr = /[Z+]/.test(rawDate.slice(-6)) ? rawDate : rawDate + 'Z';
      interaction.interactionDate = new Date(utcStr) as any;
    } else {
      interaction.interactionDate = null;
    }
    interaction.suggestionText = item.SuggestionText || item.suggestionText;
    interaction.suggestionType = item.SuggestionType || item.suggestionType;
    interaction.number = item.Number || item.number;
    interaction.contactID = item.ContactID || item.contactID;
    interaction.totalCount = item.TotalCount || item.totalCount;
    return interaction;
  }
}
